import { render } from "./CargaAsignacion.vue?vue&type=template&id=07922abd&scoped=true"
import script from "./CargaAsignacion.vue?vue&type=script&lang=js"
export * from "./CargaAsignacion.vue?vue&type=script&lang=js"

import "./CargaAsignacion.vue?vue&type=style&index=0&id=07922abd&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07922abd"]])

export default __exports__